"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionData = exports.Subscription = exports.Plan = exports.PlanEnum = exports.SubscriptionState = exports.SubscriptionStateEnum = void 0;
const z = require("zod");
const Provider_1 = require("./Provider");
const Customer_1 = require("./Customer");
var SubscriptionStateEnum;
(function (SubscriptionStateEnum) {
    SubscriptionStateEnum["Active"] = "active";
    SubscriptionStateEnum["Trial"] = "trial";
    SubscriptionStateEnum["Canceled"] = "canceled";
    SubscriptionStateEnum["Dormant"] = "dormant";
    SubscriptionStateEnum["Failed"] = "failed";
    SubscriptionStateEnum["Free"] = "free";
})(SubscriptionStateEnum = exports.SubscriptionStateEnum || (exports.SubscriptionStateEnum = {}));
exports.SubscriptionState = z.nativeEnum(SubscriptionStateEnum);
var PlanEnum;
(function (PlanEnum) {
    PlanEnum["Annual"] = "annual";
    PlanEnum["Quarterly"] = "quarterly";
    PlanEnum["Monthly"] = "monthly";
})(PlanEnum = exports.PlanEnum || (exports.PlanEnum = {}));
exports.Plan = z.nativeEnum(PlanEnum);
exports.Subscription = z.object({
    id: z.string(),
    created: z.date(),
    customerId: Customer_1.Customer.shape.customerId,
    providerCustomerId: Customer_1.Customer.shape.providerCustomerId,
    provider: Provider_1.Provider,
    isFree: z.boolean().default(false),
});
exports.SubscriptionData = z.intersection(exports.Subscription, z.object({
    nextPaymentDate: z.date(),
    previousPaymentDate: z.date().nullable(),
    currency: z.string(),
    productName: z.string(),
    productId: z.string().optional(),
    amount: z.number(),
    status: exports.SubscriptionState,
    canceledAt: z.date().nullable(),
}));
